
<template>
<div id="t">    <table style="width:100%;border-collapse: collapse;" id="t" v-if="exibitable">
                        <tr style="white-space: pre-wrap;border: 1px solid #dddddd;">
                            <th style="white-space: pre-wrap;border: 1px solid #dddddd;">Chave de acesso</th>
                            <th style="white-space: pre-wrap;border: 1px solid #dddddd;">
                                Status
                            </th>
                        </tr>
                        <tr v-for="(n,i) in  tableNotas" :key="i" style="white-space: pre-wrap;">
                            <td style="white-space: pre-wrap;border: 1px solid #dddddd; text-align:left;padding-left:7px;">{{n.chaveAcesso}}</td>
                            <td style="white-space: pre-wrap;border: 1px solid #dddddd;text-align:left;padding-left:7px;" v-if="!clickStatus">{{n.erro}}</td>
                            <td v-else style="white-space: pre-wrap;border: 1px solid #dddddd;text-align:left;padding-left:7px;">{{n.status}}</td>
                        </tr>
         </table>
         </div>
</template>

<script>

export default {
    props:['tableNotas','exibitable','clickStatus']
}
</script>

<style>
#t{  
    padding: 10px;
    overflow: auto; max-height:400px;
}
</style>